<template>
    <div class="edit">
        <div class="vcore_row">
            <div class="vcore_col--md--12 title">Update Prototype Details</div>
        </div>
        <div class="vcore_row">
            <div class="vcore_col--md--12">
                <FormPrototype class="form-prototype" :newProject=false />
            </div>
        </div>

        <div class="vcore_row button-row">
            <div class="vcore_col--xs--12">
                <button
                        class="vcore_btn vcore_btn--primary md-button blue-button"
                        type="button"
                        @click="updatePrototype"
                >Update</button>
                <button
                        class="vcore_btn vcore_btn--primary md-button red-button"
                        type="button"
                        @click="back"
                >Cancel</button>
            </div>
        </div>
        <div class="vcore_row">
            <div class="vcore_col--md--6">
                <DeployNewPrototype />
            </div>
            <div class="vcore_col--md--6">
                <DeployList
                :prototype="prototype"
                :deploys="deploys"
                :deployed="deployed"
                :totalWidth="totalWidth"
                v-on:delete="deleteAlert"
                v-on:redeploy="redeployAlert"
                />
            </div>
        </div>
        <ConfirmationModal
                v-if="showDelete"
                :confirmationMessage="'Are you sure you want to delete ' + deleteFilename + '?'"
                confirmText="Delete"
                cancelText="Cancel"
                :positive="false"
                v-on:input="confirmDelete"
        ></ConfirmationModal>
        <ConfirmationModal
                v-if="showRedeploy"
                :confirmationMessage="'Are you sure you want to make ' + redeployFilename + ' the active deploy?'"
                confirmText="Confirm"
                cancelText="Cancel"
                v-on:input="confirmRedeploy"
        ></ConfirmationModal>


    </div>
</template>

<script>
    import FormPrototype from "@/components/FormPrototype";
    import DeployList from "../components/DeployList";
    import DeployNewPrototype from "../components/DeployNewPrototype";
    import ConfirmationModal from "../components/ConfirmationModal";
    import { mapGetters, mapActions } from "vuex";

    export default {
        name: "EditPrototype",
        components: {
            FormPrototype,
            DeployList,
            DeployNewPrototype,
            ConfirmationModal
        },
        data() {
            return {
                showDelete: false,
                deleteFilename: "",
                showRedeploy: false,
                redeployFilename: ""
            }
        },
        methods: {
            ...mapActions([
                "renamePrototype",
                "createDeploy",
                "deleteDeploy",
                "redeployPrototype"
            ]),

            back(){
                this.$router.push("/");
            },
            deleteAlert(filename){
                this.showDelete = true;
                this.deleteFilename=filename;
            },
            cancelDelete(){
                this.showDelete = false;
                this.deleteFilename = "";
            },
            confirmDelete(answer){
                if(answer){
                    this.removeDeploy(this.deleteFilename);
                    this.cancelDelete();
                } else {
                    this.cancelDelete();
                }
            },
            redeployAlert(filename){
                this.showRedeploy = true;
                this.redeployFilename=filename;
            },
            cancelRedeploy(){
                this.showRedeploy = false;
                this.redeployFilename = "";
            },
            confirmRedeploy(answer){
                if(answer){
                    this.redeploy(this.redeployFilename);
                    this.cancelRedeploy();
                } else {
                    this.cancelRedeploy();
                }
            },
            removeDeploy(file) {
                this.deleteDeploy(this.$route.params.path + "/" + file)
                    // eslint-disable-next-line no-unused-vars
                    .then(result => {
                        this.$store.dispatch('populatePrototype', this.$route.params.path);
                    })
                    .catch(error => {
                        window.alert("Error deleting deploy. " + error);
                        this.$store.dispatch('populatePrototype', this.$route.params.path);
                    })
            },
            redeploy(filename) {
                this.$store.commit("updateUpdate", Date.now());
                this.redeployPrototype(this.$route.params.path + "/" + filename)
                    // eslint-disable-next-line no-unused-vars
                    .then(result => {
                        this.$store.dispatch('populatePrototype', this.$route.params.path);
                        //window.alert("Redeploy successful.");
                    })
                    .catch(error => {
                        window.alert("there was an error during redeploy. " + error);
                    })
            },
            updatePrototype() {
                this.$store.commit("updateUpdate", Date.now());
                this.renamePrototype(this.$route.params.path)
                    // eslint-disable-next-line no-unused-vars
                    .then(result => {
                        //window.alert("Prototype successfully updated.");
                        this.$router.push("/");
                        this.$store.dispatch('clearPrototype');
                    })
                    .catch(error => {
                        window.alert("There was an error during submission. " + error);
                    })
            },

        },
        computed: {
            ...mapGetters([
                "prototype",
                "deployed",
                "deploys",
                "file",
                "totalWidth"
            ])
        },
        mounted() {
            this.$store.dispatch('populatePrototype', this.$route.params.path);
        }
    }
</script>

<style lang="scss" scoped>
    .no-padding-left {
        padding-left: 0;
    }

    .form-prototype{
        margin-bottom: 15px;
    }

    .edit {
        margin-top: 50px;
    }

    .title {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 35px;
        text-align: left;
        color: #666666;
        padding-bottom: 15px;
    }

    .button-row {
        margin-top: 10px;
        margin-bottom: 5px;
    }

    .vcore_btn {
        float: right;
        margin-left: 10px;
    }

    .md-button {
        font-size: 16px;
        font-weight: 600;
        padding: 10px 30px;
        min-width: 150px;
    }
</style>
